// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1TCYr","footer":"ReportModalFilter_footer__31NRb"};